export default "__VITE_ASSET__$Gi0opvY__"